import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DowloadCenterTable from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

const client = "e3";
const table_name = "e3_download_center";

export default function E3DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route
        index
        element={<DowloadCenterTable client={client} table_name={table_name} />}
      />
    </Routes>
  );
}
